import { z } from 'zod';

/**
 * ZOD SCHEMAS: Runtime validation for all external data.
 * These are mapped 1:1 with database.types.ts but provide runtime safety.
 */

export const EventSchema = z.object({
    id: z.string().uuid(),
    user_id: z.string().uuid(),
    type: z.string(),
    status: z.enum(['PLANNED', 'COMPLETED', 'SKIPPED', 'RESCHEDULED', 'ACTIVE']),
    start_time: z.string(),
    end_time: z.string().nullish(),
    label: z.string().nullish(),
    summary: z.string().nullish(),
    payload: z.record(z.string(), z.any()).nullish(),
    preview_data: z.record(z.string(), z.any()).nullish(),
    completed_session_id: z.string().uuid().nullish(),
    sleep_log_id: z.string().uuid().nullish(),
    mobility_log_id: z.string().uuid().nullish(),
    nutrition_log_id: z.string().uuid().nullish(),
    supplement_log_id: z.string().uuid().nullish(),
    program_day_id: z.string().uuid().nullish(),
    created_at: z.string().nullish(),
    updated_at: z.string().nullish()
});

export const PerformanceLogSchema = z.object({
    id: z.string().uuid(),
    completed_session_id: z.string().uuid().nullable(),
    block_item_id: z.string().uuid().nullable(),
    exercise_library_id: z.string().uuid().nullable(),
    exercise_name_snapshot: z.string().nullable(),
    target_snapshot: z.string().nullable(),
    weight: z.string().nullable(),
    reps: z.number().nullable(),
    rpe: z.number().nullable(),
    duration_seconds: z.number().nullable(),
    distance_meters: z.number().nullable(),
    set_number: z.number(),
    created_at: z.string().nullable(),
    updated_at: z.string().nullable()
});

export const CompletedSessionSchema = z.object({
    id: z.string().uuid(),
    user_id: z.string().uuid(),
    program_day_id: z.string().uuid().nullable(),
    session_id: z.string().uuid().nullable(),
    start_time: z.string(),
    end_time: z.string(),
    notes: z.string().nullable(),
    created_at: z.string().nullable(),
    updated_at: z.string().nullable()
});

export const SleepLogSchema = z.object({
    id: z.string().uuid(),
    user_id: z.string().uuid().nullable(),
    start_time: z.string(),
    end_time: z.string().nullable(),
    quality_rating: z.number().nullable(),
    notes: z.string().nullable(),
    created_at: z.string().nullable(),
    updated_at: z.string().nullable()
});

// TYPES DERIVED FROM ZOD (Runtime Safe)
export type Event = z.infer<typeof EventSchema>;
export type PerformanceLog = z.infer<typeof PerformanceLogSchema>;
export type CompletedSession = z.infer<typeof CompletedSessionSchema>;
export type SleepLog = z.infer<typeof SleepLogSchema>;
